module.exports = __webpack_public_path__ + "img/c1.95c5e5e6.png";